import { PreviewDataset } from '../preview.types';
import { aviationDataset } from './aviation';

// Registry of preview datasets, keyed by code. "Support more than one sample dataset" lives
// here: adding a dataset = author another PreviewDataset and register it below. There is no
// prospect-facing switcher at launch — `aviation` is the only one shipped.
const datasets: Record<string, PreviewDataset> = {
  [aviationDataset.code]: aviationDataset,
};

// A dataset built at RUNTIME from real data (the "Show my team" mode), NOT part of the synthetic
// registry above. Held in memory only — never persisted — and rebuilt from a fresh authenticated
// read on each armed boot; cleared on exit. This is the one place the sandbox renders real data,
// bounded by ADR 0001 Amendment 1. It is deliberately kept out of `datasets`/`listDatasetCodes`
// so the synthetic-fixture invariants (and their referential tests) never see it.
let runtimeDataset: PreviewDataset | null = null;

export function setRuntimeDataset(dataset: PreviewDataset | null): void {
  runtimeDataset = dataset;
}

export const DEFAULT_DATASET_CODE = aviationDataset.code;

export function getDataset(code: string = DEFAULT_DATASET_CODE): PreviewDataset | undefined {
  if (runtimeDataset && runtimeDataset.code === code) return runtimeDataset;
  return datasets[code];
}

export function listDatasetCodes(): string[] {
  return Object.keys(datasets);
}
